import { Component, OnInit } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { EfileService } from 'src/app/services/efile.service';
import { CaseService } from 'src/app/services/case.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DatePipe } from '@angular/common';
import { IApplicant } from 'src/app/shared/classes/applicant';
import { IAgency } from 'src/app/shared/classes/agency';
//
import { EFileApplicationDto } from './dto/efile-app.dto';
import { EFilePaymentDto } from './dto/efile-payment.dto';

import * as theGlobals from 'src/app/shared/globals';
import {CookieService} from 'ngx-cookie-service';


@Component({
    selector: 'efile-import',
    templateUrl: './efile.component.html',
})

export class EfileImportComponent implements OnInit {

    allowImport: boolean = theGlobals.allowEFileImport;
    allowReject: boolean = theGlobals.allowEfileRejection;

    myYear: string;
    myCase: any;
    myApplicant: any;
    myAgency: any;
    myProperty: any;
    myValue: any;
    myFacts: any;
    myPayment: any;
    //
    yearList: string[];
    //
    rollTypeList: string = 'Unknown,Regular,Supplemental,Roll Change,Escape,Calamity,Penalty';
    paymentList: EFilePaymentDto[]; // will contain ALL payment transactions collected by EFiling
    applicationList: EFileApplicationDto[];
    applicantList: IApplicant[];  // for look up to match applicant
    agencyList: IAgency[];
    selectedCases: any[];
    searchString: any;
    efiledData: any;
    cols: any[];
    //
    dictionaryList: any;
    statusList: [];
    subStatusList: [];
    cityList: string[];
    payStatusList: any[];   // payment statuses (from EFiling)

    displayState: any = {
        indexDiv: false,
        workingDiv: false,
        gridDiv: false,
        summaryDiv: false,
        caseListDiv: false,
    };

    filterOptions: any = {
        filterText: '',
    };

    userName = '';
    userRole = '';   // i.e. Administrator, Assessor, Assessor-Manager, etc...

    constructor(private efileService: EfileService, private caseService: CaseService,
                private dictService: DictionaryService, private messageService: MessageService,
                private confirmationService: ConfirmationService, private datePipe: DatePipe,
                private utilService: UtilitiesService, private cookieService: CookieService) { }

    ngOnInit() {

      let uRole = this.cookieService.get('userRole'); // get the role from login cookie
      if (uRole) {
        this.userRole = uRole;
      } else {
        uRole = this.userRole;
      }
      this.userName = this.cookieService.get('userName');
      this.allowReject = this.rejectAllowed();  // determine if rejection of applications is allowed!
      this.cols = [
            { field: 'dateUpdated', header: 'Filing Date'},
            { field: 'applicantName', header: 'Applicant'},
            { field: 'parcelNumber', header: 'APN'},
            { field: 'propertyLocationView', header: 'Situs or Location'},
            { field: 'agentName', header: 'Agent' },
        ];
        this.searchString = { applicantName: '', agentName: '' };
        this.selectedCases = [];
        this.efiledData = null;

        // get Dictionaries - NEEDED??
        this.dictionaryList = this.dictService.getDictionaries();
        this.statusList = this.dictionaryList.statusChoices;
        this.subStatusList = this.dictionaryList.subStatusChoices;
        this.cityList = this.dictionaryList.cityChoices;
        this.payStatusList = this.dictionaryList.paymentStatusTypes;
        // this.utilService.doAudit(this.dictionaryList);
        // finally, get list of applications E-filed during specified year...
        this.getYearList();
        this.getEfiledAppList();
    }

    rejectAllowed(): boolean {
      // apply additional checks for allowing rejection of applications!
      // for now, based on user name, but will probably want to incorporate User Role in logic...
      const myUser = this.userName.toLowerCase();
      if (myUser.substring(myUser.length - 11) === 'parodan.com') {
        return true;
      } else if (myUser.substring(0, 16) === 'gerard_rodriguez') {
        return true;
      } else if (myUser.substring(myUser.length - 20) === 'mesasystemsgroup.com') {
        return true;
      } else {
        return false;
      }
    }
      // generate a list of years to display, based on current year (for now, allow users to go back 5 years)
    getYearList() {
        this.yearList = [];
        const calYear = new Date().getFullYear();
        const baseYr = calYear - 10;
        for (let yr = calYear; yr > baseYr; yr--) {
          this.yearList.push(yr.toString());
        }
        this.myYear = this.myYear ? this.myYear : (calYear).toString();
    }

    selectYear(ev: Event) {
        this.utilService.doAudit('Select Year Event: ' + ev);
        this.getEfiledAppList();
    }

    // get list of applications Efiled during specified year
    getEfiledAppList() {
        this.displayState.summaryDiv = false;
        this.displayState.workingDiv = true;
        const calYear = new Date().getFullYear();
        const statusCode = 3; // (+this.myYear == calYear) ? 4 : 3;
        // this.utilService.doAudit('status code: ' + statusCode);
        this.efileService.getApplicationList(this.myYear, statusCode).subscribe(data => {
            // this.utilService.doAudit('returned from getting cases efiled during: ' + this.myYear);
            // this.utilService.doAudit(data);
            if (data) {
                this.applicationList = data;
                let loc = '';
                let i;
                for (i = 0; i < this.applicationList.length; i++) {
                    if (this.applicationList[i].propertyLocation) {
                        loc = this.applicationList[i].propertyLocation;
                    } else {
                        loc = this.applicationList[i].streetNumber + ' ' + this.applicationList[i].streetAddress;
                        if (this.applicationList[i].unit) {
                            loc = loc + ' unit ' + this.applicationList[i].unit;
                        }
                    }
                    this.applicationList[i].propertyLocationView = loc;
                    if (this.applicationList[i].agentName === ', ') {
                        this.applicationList[i].agentName = '';
                    }
                    if (this.applicationList[i].dateUpdated) {
                        this.applicationList[i].dateUpdated = this.utilService.convertUTCtoLocal(this.applicationList[i].dateUpdated);
                    }
                }
            }
            this.displayState.workingDiv = false;
            this.displayState.indexDiv = true;
        });
    }

    // imported functions
    importApplication(row: any) {
        this.utilService.doAudit('ready to import application');
        this.utilService.doAudit(row);
        this.displayState.indexDiv = false;
        this.displayState.applicantDiv = false;
        this.displayState.agentDiv = false;
        this.getEfiledApplication(row.applicationId, row.propertyLocationView);
    }

    getEfiledApplication(efileId: any, propLoc: string) {
        this.utilService.doAudit('getting application; efileId: ' + efileId);
        this.efileService.getEfiledApplication(efileId).subscribe(data => {
            this.utilService.doAudit(data, 'efiled application data:');
            this.efiledData = data;
            // NOTE:   ReceivedDate is CORRECT, i.e. handles Time Zone; SEE CASES 2020-001 - 2020-003
            let applicantName = this.efiledData.applicationApplicantDto.lastName;
            if (this.efiledData.applicationApplicantDto.firstName) { applicantName = applicantName + ', ' + this.efiledData.applicationApplicantDto.firstName; }
            if (this.efiledData.applicationApplicantDto.middleInitial) { applicantName = applicantName + ' ' + this.efiledData.applicationApplicantDto.middleInitial; }
            this.efiledData.applicantFullName = applicantName;
            this.efiledData.parcelNumber = data.applicationPropertyDto.parcelNumber;
            this.efiledData.situs = propLoc;
            let irType = data.applicationAssessmentDto.typeOfAssessmentId ?? 0;
            const xType = this.rollTypeList.split(',')[irType];
            this.efiledData.rollType = xType;
            this.efiledData.rollYear = data.applicationAssessmentDto.rollYear;
            this.searchString.applicantName = this.efiledData.applicationApplicantDto.lastName;  // applicantName;
            this.utilService.doAudit('leaving getEfiledApplication; applicant name: ' + this.efiledData.applicantFullName);
            this.displayState.workingDiv = false;
            this.displayState.summaryDiv = true;
        });
    }

    cancelImport() {
        this.displayState.applicantDiv = false;
        this.displayState.agentDiv = false;
        this.displayState.summaryDiv = false;
        this.displayState.workingDiv = false;
        this.displayState.indexDiv = true;
        this.efiledData = {};
        this.applicantList = [];
        this.searchString = { applicantName: '', agentName: '' };
    }

    rejectApp(row: any) {
      const efileId = row.applicationId;  // e-filed app ID
      const rejectStatus = '6';
      const applicantName = 'Applicant: ' + row.applicantName;
      const confText = applicantName + '.<br><br>Do you want to REJECT this application?'
      this.utilService.doAudit('reject application; efileId: ' + efileId + '; applicant: ' + applicantName);
      // should we collect a REASON for the rejection?? and pass it along to the user??
      this.confirmationService.confirm({
        message: confText,
        header: 'Reject Application Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.showToast({severity: 'info', detail: 'Application would be rejected here...', summary: 'Testing'});
          this.getEfiledAppList();
        },
        reject: () => {
          this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
        }
      });
      return true;

    }
    rejectAppPROD(row: any) {
      const efileId = row.applicationId;  // e-filed app ID
      const rejectStatus = '6';
      const applicantName = 'Applicant: ' + row.applicantName;
      this.utilService.doAudit('reject application; efileId: ' + efileId + '; applicant: ' + applicantName);
      // should we collect a REASON for the rejection?? and pass it along to the user??
      this.confirmationService.confirm({
        message: applicantName + '\n' + 'Do you want to REJECT this application?',
        header: 'Reject Application Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.efileService.updateEfileStatus(efileId, rejectStatus).subscribe(data => {
            // we should probably keep an audit trail of the rejection!
            this.getEfiledAppList();
          });
        },
        reject: () => {
          this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
        }
      });
      return true;
    }
  withdrawApp(row: any) {
    const efileId = row.applicationId;  // e-filed app ID
    const withdrawStatus = '5';
    const applicantName = 'Applicant: ' + row.applicantName;
    const confText = applicantName + '.<br><br>Do you want to WITHDRAW this application?'
    this.utilService.doAudit('withdraw application; efileId: ' + efileId + '; applicant: ' + applicantName);
    // should we collect a REASON for the withdrawal?? and pass it along to the user??
    this.confirmationService.confirm({
      message: confText,
      header: 'Withdraw Application Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.showToast({severity: 'info', detail: 'Application would be withdrawn here...', summary: 'Testing'});
        this.getEfiledAppList();
      },
      reject: () => {
        this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
      }
    });
    return true;
  }

    viewDoc(row: any) {
        if (!row.applicationId) {
            this.showToast({ key: 'info', severity: 'error', detail: 'Sorry, there is a problem with this application. Please notify technical support.', summary: 'Error:' });
            return;
        }

        const myId = this.utilService.genEncryptId(row.applicationId);
        // var xURL = '../Efile/CreateAAPDF?id=' + myId;
        // let xURL = 'http://aaefile.azurewebsites.net/mgmtsiteAccess/createaapdf?id=' + myId;
        // xURL = 'https://aaefile.azurewebsites.net/Home/CreateAAPDF?id=' + myId;
        let xURL = this.utilService.getCreatePdfUrl();
        xURL = xURL + myId;
        // open a window/tab
        window.open(xURL, '_blank');

    }

    // perform update to Appeals Management Database
    postApplication() {
        this.utilService.doAudit('Posting application...');
        this.displayState.summaryDiv = false;
        this.displayState.workingDiv = true;
        this.mapDataToMgmtFormatAndSave(this.efiledData.id);
    }

    // map the Efiled application data to corresponding Appeals Management fields, create new case, assign new Case#, then update EFile DB (application status, Case#)
    mapDataToMgmtFormatAndSave(efileId: string) {
        this.myCase = {};
        this.myApplicant = {};
        this.myAgency = {};
        this.myProperty = {};
        this.myValue = {};
        this.myFacts = {};
        this.utilService.doAudit('about to get Efiled application data... again...');
        this.efileService.getEfiledApplication(efileId).subscribe(data => {
            this.utilService.doAudit(data, 'getEfiledApplication response:');
            this.efiledData = data;
            this.myCase = this.mapCase();
            this.myApplicant = this.mapApplicant();
            this.myAgency = this.mapAgent();
            this.utilService.doAudit(this.myAgency, 'mapped agency data');
            this.myProperty = this.mapProperty();
            this.myValue = this.mapValue();
            if (this.efiledData.applicationAssessmentDto) {
                const xTypeId = this.efiledData.applicationAssessmentDto.typeOfAssessmentId;
                if (xTypeId === 1) {
                    this.myValue.assessType = 'Regular';
                } else if (xTypeId === 2) {
                    this.myValue.assessType = 'Supplemental';
                } else if (xTypeId === 3) {
                    this.myValue.assessType = 'Roll Change';
                } else if (xTypeId === 4) {
                    this.myValue.assessType = 'Escape';
                } else if (xTypeId === 5) {
                    this.myValue.assessType = 'Calamity';
                } else if (xTypeId === 6) {
                    this.myValue.assessType = 'Penalty';
                }

                const xYear = this.efiledData.applicationAssessmentDto.rollYear;
                let nextYear = '';
                if (Number(xYear)) {
                    nextYear = xYear + 1;
                    // convert to format: yr/yr+1, e.g. 2025/2026; was previously deprecated; restored 12/26/2025
                    this.myProperty.rollYear = xYear.toString() + '/' + nextYear; // + '/' + nextYear;
                } else {
                    // IFF it's a Regular assessment type, should we default to the current year?? - rod 12/26/2025
                    // Question: will/should E-filing ever allow a Regular appeal outside the current year??
                    this.myProperty.rollYear = '';
                }
            }
            this.myFacts = this.mapFacts();
            // get Payment transactions
            this.efileService.getPaymentInfo(efileId).subscribe(payments => {
                const compTrans = payments.filter(pay => {
                    return pay.statusId === 3 ? pay : null; // only pick up transactions with "Completed" status
                });
                this.utilService.doAudit(compTrans, 'compTrans:');
                if (compTrans.length > 0) {
                    const payRec = compTrans[0];
                    this.utilService.doAudit(payments, 'payment records');
                    this.myCase.receiptNum = payRec.transactionId;
                    const payDate = this.utilService.formatDate(payRec.paymentDate, '/', true, true);
                    // add comment to Case comment; convert payment Date??
                    this.myCase.comment = this.myCase.comment + '\nPayment of $' + payRec.appliedAmount + ' was submitted by: ' + payRec.username + ', on: ' + payDate + '.';
                }
                // now, do actual saving...
                this.saveCase(efileId);
            });
        });
    }

    // update Appeals Management DB by creating a new case using the mapped application data
    saveCase(efileId: string) {
        const myApplication = {
            case: {},
            applicant: {},
            agency: {},
            property: {},
            caseValue: {
                assessType: '',
                totalValue: null,
                valueDifference: null,
                applicantGroup: {},
                assessorGroup: {},
                opinionGroup: {},
                finalGroup: {}
            },
            caseFacts: [],
            caseStatus: '',
            efileId: '',
        };

        // calculateTotalValue();
        this.myProperty.apn = this.stripDashes(this.myProperty.apn);
        myApplication.case = this.myCase;
        myApplication.applicant = this.myApplicant;
        myApplication.agency = this.myAgency;
        myApplication.property = this.myProperty;
        myApplication.caseValue = this.myValue;
        myApplication.caseValue.assessorGroup = {};
        myApplication.caseValue.finalGroup = {};
        myApplication.caseFacts = this.myFacts;
        myApplication.efileId = efileId;

        this.utilService.doAudit(myApplication, 'saving case; myApplication:');
        // added 12/11/14
        // angular.copy(this.myAgency, this.lastAgency);

        // let xAppID;
        let theCaseYear = 0;
        // let mgmtCaseNumber;
        myApplication.caseStatus = 'Ready for Hearing';
        theCaseYear = new Date().getFullYear();
        this.utilService.doAudit(myApplication, 'ready to save application for year: ' + theCaseYear + '; myApplication data:');

        // save new case
        this.caseService.createCase(myApplication, theCaseYear).subscribe(data => {
            this.utilService.doAudit('returned from createCase service: ' + data);
            if (data) {
                this.getNewCaseNumber(data, efileId);
                // MAKE ENTRY INTO MGT APP AUDIT TRAIL!  - to mark when Application was imported and by who
            } else {
                alert('Failed to save. If the problem persists, please notify support');
            }
            this.cancelImport();
        });
    }

    getNewCaseNumber(newApplicationId: any, efileId: string) {
        this.caseService.getNewCaseNumber(newApplicationId).subscribe(data => {
            const xMsg = 'Case number ' + data.caseNum + ' saved.';
            alert(xMsg);
            if (data.caseNum) {
                this.passMgmtCaseNumberToEfile(data.caseNum, efileId);  // send Case# to EFile database, update Efile Status
            } else {
                alert('Unable to generate new Case #');
            }
        });
    }

    passMgmtCaseNumberToEfile(mgmtCaseNum: string, efileId: string) {
        this.efileService.updateEfileMgtCaseNumber(mgmtCaseNum, efileId).subscribe(data => {
            if (data) {
                this.updateEfileStatus(efileId, '4');   // update the application's Efile Status to "Accepted"
            } else {
                alert('Problem updating E-Filing system with new Case #');
           }
        });
    }

    updateEfileStatus(efileId, efileStatus: string) {
        this.efileService.updateEfileStatus(efileId, efileStatus).subscribe(data => {
            this.getEfiledAppList();
        });
    }

    getTodaysDate() {
        const today = new Date();
        const dd = today.getDate();
        const mm = today.getMonth() + 1; // January is 0!
        const yyyy = today.getFullYear();
        let tDay = '';
        let tMonth = '';
        let tToday = '';
        if (dd < 10) {
            tDay = '0' + dd;
        }
        if (mm < 10) {
            tMonth = '0' + mm;
        }
        tToday = mm + '/' + dd + '/' + yyyy;
        return tToday;
    }

    getTodaysYear() {
        const yyy = new Date().getFullYear;
        return yyy;
    }

    stripDashes(x) {
        if (x === null || x === undefined) {
            return '';
        }
        return x.toString().replace(/-/g, '');
    }


    // Mapping Methods

    mapCase() {
        let dateReceived = this.efiledData.dateSubmitted;
        if (dateReceived) {
            // we're assuming this is UTC time!
            dateReceived = this.utilService.convertUTCtoLocal(this.efiledData.dateSubmitted).toDateString();
            this.utilService.doAudit(dateReceived, 'converted Date Received: ');
        } else {
            dateReceived = this.getTodaysDate();
        }
        dateReceived = this.datePipe.transform(dateReceived, 'yyyy-MM-dd hh:mm:ss');
        //
        this.utilService.doAudit('Date submitted: ' + this.efiledData.dateSubmitted + '; date Received: ' + dateReceived);
        //
        let claimRefund = this.efiledData.isClaimForRefund;
        if (claimRefund === true) {
            claimRefund = 'Yes';
        } else {
            claimRefund = 'No';
        }
        const applicantType = this.efiledData.applicationCertificationDto ? this.efiledData.applicationCertificationDto.filingStatus : '';
        const commentText = 'E-filed.';   // **NOTE:  should we include who imported the application and when??
        // process Payment info from EFiling; assumes there'll be at least one "completed" transaction, indicating a payment was processed successfully!
        const receiptNum = '';
        return {
            dateReceived,
            requestFinding: this.efiledData.areFindingsRequested,
            claimRefund,
            applicantType,
            comment: commentText,
            receiptNum
        };
    }

    mapApplicant() {
        let applicantName = this.efiledData.applicationApplicantDto.lastName;
        if (this.efiledData.applicationApplicantDto.firstName) {
            applicantName = applicantName + ', ' + this.efiledData.applicationApplicantDto.firstName;
        }
        if (this.efiledData.applicationApplicantDto.middleInitial) {
            applicantName = applicantName + ' ' + this.efiledData.applicationApplicantDto.middleInitial;
        }
        return {
            name: applicantName.toUpperCase(),
            phone: this.efiledData.applicationApplicantDto.dayPhone,
            email: this.efiledData.applicationApplicantDto.email,
            altPhone: this.efiledData.applicationApplicantDto.altPhone,
            strAddr: this.efiledData.applicationApplicantDto.mailingAddress.toUpperCase(),
            fax: this.efiledData.applicationApplicantDto.faxPhone,
            city: this.efiledData.applicationApplicantDto.city.toUpperCase(),
            state: this.efiledData.applicationApplicantDto.state.toUpperCase(),
            zip: this.efiledData.applicationApplicantDto.zipcode,
            sign: true
        };
    }

    mapAgent() {
        if (!this.efiledData.applicationAgentDto) {
            return {
                name: '',
                phone: '',
                contact: '',
                email: '',
                altPhone: '',
                strAddr: '',
                fax: '',
                city: '',
                state: '',
                zip: ''
            };
    }
        let contactName = this.efiledData.applicationAgentDto.lastName;
        if (this.efiledData.applicationAgentDto.firstName) {
            contactName = contactName + ', ' + this.efiledData.applicationAgentDto.firstName;
        }
        if (!contactName) {
            contactName = this.efiledData.applicationAgentDto.contactPerson;
        }
        return {
            name: this.efiledData.applicationAgentDto.companyName.toUpperCase(),
            phone: this.efiledData.applicationAgentDto.dayPhone,
            contact: contactName.toUpperCase(),
            email: this.efiledData.applicationAgentDto.email,
            altPhone: this.efiledData.applicationAgentDto.altPhone,
            strAddr: this.efiledData.applicationAgentDto.mailingAddress.toUpperCase(),
            fax: this.efiledData.applicationAgentDto.faxPhone,
            city: this.efiledData.applicationAgentDto.city.toUpperCase(),
            state: this.efiledData.applicationAgentDto.state.toUpperCase(),
            zip: this.efiledData.applicationAgentDto.zipcode
        };
    }

    mapProperty() {
        let streetAddress = this.efiledData.applicationPropertyDto.addressOrLocation;
        if (this.efiledData.applicationPropertyDto.streetAddress) {
            streetAddress = this.efiledData.applicationPropertyDto.streetAddress;
            if (this.efiledData.applicationPropertyDto.unit) {
                streetAddress = streetAddress + ' Unit ' + this.efiledData.applicationPropertyDto.unit;
            }
            if (this.efiledData.applicationPropertyDto.city) {
                // try to find a matching City from the dictionary (independent of case)
                const matchCity = this.cityList.filter(city => {
                    return city.toLowerCase() === this.efiledData.applicationPropertyDto.city.toLowerCase() ? city : null;
                });
                if (matchCity.length > 0) {
                    this.utilService.doAudit('converted city; from: ' + this.efiledData.applicationPropertyDto.city + ' to: ' + matchCity[0]);
                    this.efiledData.applicationPropertyDto.city = matchCity[0];
                }
            }
        }
        return {
            secured: '',
            apn: this.efiledData.applicationPropertyDto.parcelNumber,
            strNum: this.efiledData.applicationPropertyDto.streetNumber,
            street: streetAddress.toUpperCase(),
            city: this.efiledData.applicationPropertyDto.city,
            type: this.efiledData.applicationPropertyDto.propertyType,
            ownOccupy: this.efiledData.applicationPropertyDto.isSingleFamilyPrincipalResidence
        };
    }

    mapValue() {
        const rollValuePerApplicant = this.efiledData.applicationRollValueDto;
        const opinionValue = this.efiledData.applicationOpinionValueDto;

        return {
            applicantGroup: {
                landValue: rollValuePerApplicant.land,
                improveValue: rollValuePerApplicant.improvements,
                fixturesValue: rollValuePerApplicant.fixtures,
                personalValue: rollValuePerApplicant.personalProperty,
                mineralValue: rollValuePerApplicant.mineralRights,
                treesValue: rollValuePerApplicant.treesAndVines,
                penaltyValue: rollValuePerApplicant.penalties
            },
            opinionGroup: {
                landValue: opinionValue.land,
                improveValue: opinionValue.improvements,
                fixturesValue: opinionValue.fixtures,
                personalValue: opinionValue.personalProperty,
                mineralValue: opinionValue.mineralRights,
                treesValue: opinionValue.treesAndVines,
                penaltyValue: opinionValue.penalties
            }
        };
    }

    mapFacts() {
        const factsList = [];
        const efiledFacts = this.efiledData.applicationFactDto;
        if (efiledFacts.declineInValue) {
            factsList.push('Decline in Value:  The Assessor\'s roll value exceeds the market value as of the lien date.');
        }
        if (efiledFacts.noChangeInOwnership) {
            factsList.push('Change in Ownership-No reassessable event occurred.');
        }
        if (efiledFacts.cioBaseYearValueIncorrect) {
            factsList.push('Change in Ownership-Base year value is incorrect.');
        }
        if (efiledFacts.noNewConstruction) {
            factsList.push('New Construction-No reassessable event occurred.');
        }
        if (efiledFacts.ncBaseYearValueIncorrect || efiledFacts.ncValueOfConstructionIncorrect) {
            factsList.push('New Construction-Base year value is incorrect.');
        }
        if (efiledFacts.calamityReassessment) {
            factsList.push('Calamity:  Assessor\'s reduced value incorrect for property damaged by misfortune or calamity.');
        }
        if (efiledFacts.penaltyAssessment) {
            factsList.push('Penalty Assessment:  Penalty assessment is not justified.');
        }
        if (efiledFacts.businessPersonalPropFixtures || efiledFacts.businessPersonalPropPartial) {
            factsList.push('Personal Property/Fixtures');
        }
        if (efiledFacts.propertyClassification || efiledFacts.propertyAllocation) {
            factsList.push('Classification');
        }
        if (efiledFacts.amountOfEscapeAssessment || efiledFacts.assessmentOfOtherProperty) {
            factsList.push('Appeal after an Audit');
        }
        if (efiledFacts.other) {
            factsList.push('Other');
        }
        return factsList;
    }

    // end of import/posting related methods

    // Methods not currently being used; to allow matching of Applicants and Agencies from Management DB
    // get list of possible (matching) applicants
    getApplicantList() {
        let xString = this.searchString.applicantName;
        xString = xString.replace(/[|&;$%@"<>()+.]/g, '');
        this.caseService.findApplicant(xString).subscribe(data => {
            this.applicantList = data;
            this.displayState.workingDiv = false;
            if (!data.length) {
                this.showToast({severity: 'info', detail: 'No matching Applicant found', summary: 'Info'});
            }
        });
    }

    applicantSelected(item: any) {
        this.efiledData.applicantMatchedId = item.id;
        this.displayState.applicantDiv = false;
        this.readyAgentSearch();
    }

    applicantNoMatch() {
        this.efiledData.applicantMatchedId = null;
        this.displayState.applicantDiv = false;
        this.readyAgentSearch();
    }

    clearApplicantList() {
        this.applicantList = [];
    }


    // agents
    readyAgentSearch() {
        if (this.efiledData.applicationAgentDto.companyName) {
            this.searchString.agentName = this.efiledData.applicationAgentDto.companyName;
            this.displayState.agentDiv = true;
        } else if (this.efiledData.applicationAgentDto.lastName) {
            this.searchString.agentName = this.efiledData.applicationAgentDto.lastName;
            this.displayState.agentDiv = true;
        } else {
            this.displayState.agentDiv = false;
            this.displayState.summaryDiv = true;
        }
    }

    getAgencyList() {
        // populate list of possible agencies
        let xString = this.searchString.agentName;
        xString = xString.replace(/[|&;$%@"<>()+.]/g, '');
        this.caseService.findAgency(xString).subscribe(data => {
            this.agencyList = data;
            if (!data.length) {
                this.showToast({severity: 'info', detail: 'No matching Agent found', summary: 'Info'});
            }

        });
    }

    agencySelected(item: any) {
        this.efiledData.agentMatchedId = item.id;
        this.displayState.agentDiv = false;
        this.displayState.summaryDiv = true;
    }

    agentNoMatch() {
        this.efiledData.agentMatchedId = null;
        this.displayState.agentDiv = false;
        this.displayState.summaryDiv = true;
    }

    clearAgencyList() {
        this.agencyList = [];
    }

    // Toaster-related methods
    showToast(msg: Message) {
        this.messageService.add(msg);
      }

    clear() {
        this.messageService.clear();
    }
}
